/* NOIRE – upsell / downsell панел след „Добави в количката“ (данните и текстовете идват от snippets/sk-upsell.liquid) */
(function () {
  if (window.__skup) return; window.__skup = true;
  var dataEl = document.getElementById('skup-data');
  if (!dataEl) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = D.p || {};
  var MF = D.moneyFormat || ('€' + '{' + '{amount_with_comma_separator}' + '}');
  var SIZES = ['XS-S', 'M-L', 'XL-XXL'];
  var SW = { Noire: '#111111', Truffle: '#7a5a47', Bison: '#4b3427', Oatmilk: '#e9e0cf' };
  var GIFT_ART = '<svg viewBox="0 0 80 64" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><rect width="80" height="64" fill="#0a0a0a"/><circle cx="40" cy="32" r="14" fill="none" stroke="#e2d3b3" stroke-width="11"/><circle cx="40" cy="32" r="14" fill="none" stroke="#a8956f" stroke-width="11" stroke-dasharray="1.5 6.3"/></svg>';
  var ICON_OK = '<svg class="skup__ok" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="12"/><path d="M7 12.4l3.3 3.3L17.2 8.8"/></svg>';
  var ICON_PERK = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2.5 7.3l2.9 2.9 6.1-6.4" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rich(s) { return esc(s).replace(/\*([^*]+)\*/g, '<b>$1</b>'); }
  function marked(s, word) {
    var t = esc(s); if (!word) return t;
    var w = esc(word), i = t.toLowerCase().indexOf(w.toLowerCase());
    return i < 0 ? t : t.slice(0, i) + '<mark>' + t.slice(i, i + w.length) + '</mark>' + t.slice(i + w.length);
  }
  function money(cents, short) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    var comma = /comma_separator/.test(MF);
    var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var s = (short && parts[1] === '00') ? intp : intp + (comma ? ',' : '.') + parts[1];
    return MF.replace(/\{\{\s*[a-z_]+\s*\}\}/, s).replace(/<[^>]*>/g, '');
  }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function opts(v) { return (v && v.o || []).filter(function (x) { return x && x !== 'Default Title'; }); }
  function isSize(x) { return SIZES.indexOf(x) > -1 || /^NOIRE\s/i.test(x); }
  function values(p, kind) {
    var out = [];
    (p.variants || []).forEach(function (v) { opts(v).forEach(function (x) { if ((kind === 'size') === isSize(x) && out.indexOf(x) < 0) out.push(x); }); });
    return out;
  }
  function sizeOf(v) { return opts(v).filter(isSize)[0]; }
  function colorOf(v) { return opts(v).filter(function (x) { return !isSize(x); })[0]; }
  /* вариант по размер/цвят – наличният е с предимство */
  function pickVariant(p, want) {
    var vs = p.variants || [], i, o, hit = null;
    for (i = 0; i < vs.length; i++) {
      o = opts(vs[i]);
      if ((!want.size || o.indexOf(want.size) > -1) && (!want.color || o.indexOf(want.color) > -1)) { if (vs[i].available) return vs[i]; if (!hit) hit = vs[i]; }
    }
    return hit;
  }
  /* първият НАЛИЧЕН вариант по реда на желанията */
  function firstAvail(p, wants) {
    for (var i = 0; i < wants.length; i++) { var v = pickVariant(p, wants[i]); if (v && v.available) return v; }
    return null;
  }
  function inStock(h) { return P[h] && firstAvail(P[h], [{}]) ? P[h] : null; }
  function variantFor(it) {
    var s = SEL[it.k] || {};
    return pickVariant(it.p, s) || pickVariant(it.p, { size: s.size }) || pickVariant(it.p, {});
  }
  function available(p, size, color) { var v = pickVariant(p, { size: size, color: color }); return !!(v && v.available); }

  /* ---------- текстовете (от snippet-а) ---------- */
  var N = D.names || {};
  function nm(h, k) { return (N[h] && N[h][k]) || (P[h] && P[h].title) || ''; }
  /* {acc} = „Slip-on роклята“, {nom} = „Slip-on роклята“ / „Push-up сутиенът“, {gift} = „потник“ */
  function fill(s, step) {
    var off = OFFERS[step], g = off.items.filter(function (i) { return i.gift; })[0];
    return String(s == null ? '' : s).replace(/\{acc\}/g, nm(off.h, 'acc')).replace(/\{nom\}/g, nm(off.h, 'nom')).replace(/\{gift\}/g, g ? nm(g.h, 'acc') : '');
  }
  /* първата показана оферта взима текстовете "first", втората – "second" */
  function copy(step) {
    var pos = STEPS.indexOf(step), C = (D.copy || {})[pos > 0 ? 'second' : 'first'] || {};
    var g = ITEMS[step].some(function (i) { return i.gift; }), f = function (k) { return fill(g ? C[k + '_gift'] : C[k], step); };
    return { hello: fill(C.hello, step), head: f('head'), mark: f('mark'), sub: f('sub'), cta: f('cta'), fine: g ? fill(C.fine_gift, step) : '',
      no: fill(pos === STEPS.length - 1 ? C.no_last : C.no, step) };
  }

  /* ---------- офертите (идват от snippet-а за всеки продукт; продукт без наличност не се предлага) ---------- */
  var OFFERS = [], ITEMS = {};
  (D.offers || []).forEach(function (o) {
    if (!inStock(o.item) || o.item === D.mainHandle) return;
    var n = OFFERS.length, items = [{ k: 'a' + n, h: o.item, p: P[o.item], gift: false, name: nm(o.item, 'card'), pick: true, pos: '50% 22%' }];
    var gh = (o.gift === 'noire-gift-scrunchie' && !D.scrunchie) ? null : o.gift;
    if (gh && inStock(gh)) {
      var one = values(P[gh], 'size').length < 2 && values(P[gh], 'color').length < 2;
      items.push({ k: 'g' + n, h: gh, p: P[gh], gift: true, giftFor: o.item, name: nm(gh, 'card'), pick: !one, noPick: one, pos: one ? '50% 50%' : '50% 22%' });
    }
    OFFERS.push({ h: o.item, items: items }); ITEMS[n] = items;
  });
  function needSize(it) { return it.pick && values(it.p, 'size').length > 1 && !(SEL[it.k] && SEL[it.k].size); }

  var SEL = {}, STEPS = [], STEP = null, ADDED = null, CART = null, CD = null, ORIG = null, ORIG_OPEN = null, ROOT = null, LAST_FOCUS = null, OPEN = false;

  function session() { try { return window.sessionStorage; } catch (e) { return null; } }
  function seen() { var s = session(); try { return !!(s && s.getItem('skup:' + D.mainHandle)); } catch (e) { return false; } }
  function markSeen() { var s = session(); try { s && s.setItem('skup:' + D.mainHandle, '1'); } catch (e) {} }
  var ONCE = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');

  /* ---------- HTML ---------- */
  function cardHTML(it, idx) {
    var v = variantFor(it);
    var img = (v && v.img) || it.p.img;
    var pic = img ? '<img src="' + esc(sized(img, 500)) + '" alt="' + esc(it.name) + '" loading="eager" style="object-position:' + it.pos + '">' : GIFT_ART;
    var price = it.gift
      ? ((v && v.compare) ? '<s>' + money(v.compare) + '</s>' : '') + '<em>Безплатно</em>'
      : '<b>' + money(v ? v.price : 0) + '</b>' + ((v && v.compare > v.price) ? '<s>' + money(v.compare) + '</s>' : '');
    var h = '<div class="skup__card" data-k="' + it.k + '">' +
      '<div class="skup__img">' + pic + (it.gift ? '<span class="skup__badge">Подарък</span>' : '') + (idx > 0 ? '<span class="skup__plus" aria-hidden="true">+</span>' : '') + '</div>' +
      '<div class="skup__cinfo"><div class="skup__cname">' + esc(it.name) + '</div><div class="skup__price">' + price + '</div>';
    if (it.noPick) {
      h += '<div class="skup__opts"><span>Идва с поръчката</span></div>';
    } else if (it.pick) {
      h += optionsHTML(it);
    }
    return h + '</div></div>';
  }
  /* цвят и размер – винаги видими; изчерпаното е зачеркнато и не може да се избере */
  function optionsHTML(it) {
    var s = SEL[it.k] || {}, cs = values(it.p, 'color'), ss = values(it.p, 'size'), h = '';
    if (cs.length > 1) h += '<div class="skup__colors" role="group" aria-label="Цвят">' + cs.map(function (c) {
      var ok = available(it.p, s.size, c), lbl = c + (ok ? '' : (s.size ? ' – няма в ' + s.size : ' – изчерпан'));
      return '<button type="button" class="skup__sw" data-color="' + esc(c) + '" data-for="' + it.k + '" aria-pressed="' + (s.color === c) + '" aria-label="' + esc(lbl) + '" title="' + esc(lbl) + '" style="--c:' + (SW[c] || '#999') + '"' + (ok ? '' : ' disabled') + '><span></span></button>';
    }).join('') + '<span class="skup__cl">' + esc(s.color || '') + '</span></div>';
    if (ss.length > 1) h += '<div class="skup__sizes" role="group" aria-label="Размер">' + ss.map(function (x) {
      var ok = available(it.p, x, s.color);
      return '<button type="button" class="skup__pill" data-size="' + esc(x) + '" data-for="' + it.k + '" aria-pressed="' + (s.size === x) + '"' + (ok ? '' : ' disabled') + '>' + esc(x.replace(/^NOIRE\s*/i, '')) + '</button>';
    }).join('') + '</div>';
    /* размерът не е избран предварително (напр. сутиен към боди) – връзка към таблицата с размери */
    if (it.help) h += '<a class="skup__help" href="' + esc(it.p.url) + '" target="_blank" rel="noopener">Кой е моят размер?</a>';
    return h;
  }
  function sumHTML(step) {
    var add = 0, perks = [];
    ITEMS[step].forEach(function (it) {
      var v = variantFor(it);
      if (!it.gift && v) add += v.price;
    });
    var base = CART ? CART.total_price : 0, total = base + add, T = D.threshold || 0;
    if (T > 0 && base < T && total >= T) perks.push('Безплатна доставка');
    var fine = copy(step).fine;
    return '<div class="skup__sum" data-a><div class="skup__sum-r"><span>Поръчката ти става</span><b>' + money(total) + '</b></div>' +
      (perks.length ? '<div class="skup__perks">' + perks.map(function (p) { return '<span class="skup__perk">' + ICON_PERK + '<span>' + esc(p) + '</span></span>'; }).join('') + '</div>' : '') +
      (fine ? '<div class="skup__fine">' + esc(fine) + '</div>' : '') + '</div>';
  }
  function ctaText(step) {
    var c = copy(step), add = 0, need = false;
    ITEMS[step].forEach(function (it) { var v = variantFor(it); if (!it.gift && v) add += v.price; if (needSize(it)) need = true; });
    if (need) return { t: 'Избери размер', dis: true };
    return { t: c.cta + ' · ' + money(add, true), dis: false };
  }
  function viewHTML(step) {
    var c = copy(step), cta = ctaText(step), items = ITEMS[step];
    return '<h2 class="skup__h" id="skup-title" data-a>' + (c.hello ? '<span>' + esc(c.hello) + '</span>' : '') + '<span>' + marked(c.head, c.mark) + '</span></h2>' +
      (c.sub ? '<p class="skup__sub" data-a>' + rich(c.sub) + '</p>' : '') +
      '<div class="skup__cards' + (items.length === 1 ? ' is-one' : '') + '" data-a>' + items.map(cardHTML).join('') + '</div>' +
      sumHTML(step) +
      '<div class="skup__foot" data-a><p class="skup__err" data-err hidden></p>' +
      '<button type="button" class="skup__cta" data-cta aria-disabled="' + cta.dis + '">' + esc(cta.t) + '</button>' +
      '<button type="button" class="skup__no" data-no>' + esc(c.no) + '</button></div>';
  }
  function index(el) { var n = 0; el.querySelectorAll('[data-a]').forEach(function (x) { x.style.setProperty('--i', n++); }); }

  function heroUrl(step) { var it = ITEMS[step] && ITEMS[step][0]; if (!it) return ''; var v = variantFor(it); return sized((v && v.img) || it.p.img, 900); }
  function setHero(step) {
    var box = ROOT.querySelector('.skup__media'); if (!box) return;
    var url = heroUrl(step); if (!url) return;
    var old = box.querySelector('img'); if (old && old.getAttribute('src') === url) return;
    var im = new Image(); im.alt = ''; im.src = url; im.className = 'is-gone';
    box.appendChild(im);
    var show = function () { requestAnimationFrame(function () { im.classList.remove('is-gone'); if (old) { old.classList.add('is-gone'); setTimeout(function () { old.remove(); }, 500); } }); };
    if (im.complete) show(); else { im.onload = show; im.onerror = show; }
  }

  function build() {
    if (ROOT) return;
    ROOT = document.createElement('div');
    ROOT.className = 'skup'; ROOT.hidden = true;
    ROOT.innerHTML = '<div class="skup__bg" data-close></div>' +
      '<div class="skup__panel" role="dialog" aria-modal="true" aria-labelledby="skup-title" tabindex="-1">' +
        '<button type="button" class="skup__x" data-close aria-label="Затвори"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg></button>' +
        '<div class="skup__media"></div>' +
        '<div class="skup__main"><div class="skup__grab" aria-hidden="true"></div><div class="skup__head"></div><div class="skup__stage"></div></div>' +
      '</div>';
    document.body.appendChild(ROOT);
    ROOT.addEventListener('click', onClick);
    ROOT.addEventListener('keydown', onKey);
    ROOT.querySelector('.skup__panel').addEventListener('scroll', moreCue, { passive: true });
    window.addEventListener('resize', moreCue);
    drag();
  }
  /* на телефон: лека сянка над бутона, когато под него има още съдържание */
  function moreCue() {
    if (!ROOT || ROOT.hidden) return;
    var p = ROOT.querySelector('.skup__panel');
    ROOT.classList.toggle('is-more', window.innerWidth < 750 && p.scrollHeight - p.clientHeight - p.scrollTop > 6);
  }
  function headHTML() {
    var opt = (ADDED.variant_options || []).filter(function (x) { return x && x !== 'Default Title'; }).join(' · ');
    return '<div class="skup__added" data-a>' + ICON_OK + '<div class="skup__added-i"><span class="skup__added-t">Добавено в количката</span>' +
      '<span class="skup__added-s">' + esc(ADDED.product_title || ADDED.title) + (opt ? ' · ' + esc(opt) : '') + '</span></div></div>';
  }
  /* снимките на всички цветове се зареждат предварително – смяната на цвят е мигновена */
  var PRE = {};
  function preload(step) {
    (ITEMS[step] || []).forEach(function (it) {
      (it.p.variants || []).forEach(function (v) { var u = v.img && sized(v.img, 500); if (u && !PRE[u]) { PRE[u] = new Image(); PRE[u].src = u; } });
    });
  }
  function show(step) {
    build();
    STEP = step;
    preload(step);
    ROOT.querySelector('.skup__head').innerHTML = headHTML();
    var stage = ROOT.querySelector('.skup__stage');
    stage.style.height = ''; stage.classList.remove('is-anim'); /* нулира височината от предишното отваряне */
    stage.innerHTML = '<div class="skup__view">' + viewHTML(step) + '</div>';
    index(ROOT);
    setHero(step);
    ROOT.hidden = false;
    LAST_FOCUS = document.activeElement;
    document.documentElement.classList.add('skup-lock');
    OPEN = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { ROOT.classList.add('is-open'); ROOT.querySelector('.skup__panel').focus({ preventScroll: true }); }); });
    setTimeout(moreCue, 650);
  }
  function swapTo(step) {
    var stage = ROOT.querySelector('.skup__stage'), old = stage.firstElementChild;
    STEP = step;
    preload(step);
    stage.style.height = stage.offsetHeight + 'px';
    stage.classList.add('is-anim');
    old.classList.add('is-out');
    setHero(step);
    setTimeout(function () {
      var nv = document.createElement('div');
      nv.className = 'skup__view is-in';
      nv.innerHTML = viewHTML(step);
      stage.replaceChild(nv, old);
      index(nv);
      stage.style.height = nv.offsetHeight + 'px';
      var panel = ROOT.querySelector('.skup__panel'); if (panel.scrollTop) panel.scrollTo({ top: 0, behavior: 'smooth' });
      var main = ROOT.querySelector('.skup__main'); if (main.scrollTop) main.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function () { stage.style.height = ''; stage.classList.remove('is-anim'); moreCue(); }, 420);
    }, 210);
  }
  function refresh(k) {
    var view = ROOT.querySelector('.skup__stage').firstElementChild;
    view.classList.add('is-static');
    ITEMS[STEP].forEach(function (it, idx) {
      if (k && it.k !== k) return;
      var el = view.querySelector('.skup__card[data-k="' + it.k + '"]'); if (!el) return;
      var w1 = document.createElement('div'); w1.innerHTML = cardHTML(it, idx);
      var nc = w1.firstElementChild, oi = el.querySelector('.skup__img img'), ni = nc.querySelector('.skup__img img');
      if (oi && ni && oi.getAttribute('src') === ni.getAttribute('src')) ni.replaceWith(oi); /* същата снимка – без премигване */
      else if (ni) { ni.classList.add('is-new'); }
      el.replaceWith(nc);
    });
    var sum = view.querySelector('.skup__sum'); if (sum) { var w = document.createElement('div'); w.innerHTML = sumHTML(STEP); sum.replaceWith(w.firstElementChild); }
    var cta = ctaText(STEP), b = view.querySelector('[data-cta]'); b.textContent = cta.t; b.setAttribute('aria-disabled', String(cta.dis));
    setHero(STEP);
    moreCue();
  }

  function close(thenDrawer) {
    if (!OPEN) return; OPEN = false;
    ROOT.classList.remove('is-open');
    var panel = ROOT.querySelector('.skup__panel'); panel.style.transition = ''; panel.style.transform = '';
    setTimeout(function () {
      ROOT.hidden = true;
      document.documentElement.classList.remove('skup-lock');
      if (thenDrawer) thenDrawer();
      else if (LAST_FOCUS && LAST_FOCUS.focus) { try { LAST_FOCUS.focus({ preventScroll: true }); } catch (e) {} }
    }, 420);
  }
  function nextStep() {
    var i = STEPS.indexOf(STEP);
    if (i > -1 && i < STEPS.length - 1) { swapTo(STEPS[i + 1]); return; }
    close(function () { ORIG_OPEN && ORIG_OPEN.call(CD); });
  }
  function accept() {
    var view = ROOT.querySelector('.skup__view'), btn = view.querySelector('[data-cta]');
    if (btn.getAttribute('aria-disabled') === 'true') {
      var first = view.querySelector('.skup__sizes .skup__pill:not(:disabled)'); if (first) first.focus();
      var err = view.querySelector('[data-err]'); err.textContent = 'Избери размер.'; err.hidden = false; return;
    }
    var items = [], gifts = false;
    ITEMS[STEP].forEach(function (it) {
      var v = variantFor(it); if (!v) return;
      var line = { id: v.id, quantity: 1 };
      if (it.gift) { line.properties = { _gift_for: it.giftFor }; gifts = true; }
      items.push(line);
    });
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || 'error');
        var stage = ROOT.querySelector('.skup__stage');
        stage.style.height = stage.offsetHeight + 'px';
        stage.classList.add('is-anim');
        stage.innerHTML = '<div class="skup__view is-in"><div class="skup__done" data-a>' + ICON_OK + '<p>' + (gifts ? 'Готово. Подаръкът е в количката.' : 'Готово. Добавено в количката.') + '</p></div></div>';
        index(stage);
        requestAnimationFrame(function () { stage.style.height = stage.firstElementChild.offsetHeight + 'px'; });
        setTimeout(function () { close(function () { try { ORIG.call(CD, res.j); } catch (e) { ORIG_OPEN && ORIG_OPEN.call(CD); } }); }, 1250);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        var err = view.querySelector('[data-err]'); err.textContent = 'Нещо се обърка. Опитай отново.'; err.hidden = false;
      });
  }

  function onClick(e) {
    var t = e.target.closest('button, [data-close]');
    if (!t || !ROOT.contains(t)) return;
    if (t.hasAttribute('data-close')) { close(); return; }
    if (t.hasAttribute('data-no')) { nextStep(); return; }
    if (t.hasAttribute('data-cta')) { accept(); return; }
    var forK = t.getAttribute('data-for');
    if (forK && !t.disabled) {
      var s = SEL[forK] = SEL[forK] || {}, it = ITEMS[STEP].filter(function (i) { return i.k === forK; })[0];
      var attr = t.hasAttribute('data-size') ? 'data-size' : 'data-color', val = t.getAttribute(attr);
      if (attr === 'data-size') s.size = val; else s.color = val;
      /* ако комбинацията е изчерпана – най-близката налична (същият избор остава) */
      if (it && s.size && !available(it.p, s.size, s.color)) {
        var alt = attr === 'data-size' ? firstAvail(it.p, [{ size: s.size }]) : firstAvail(it.p, [{ color: s.color }]);
        if (alt) { s.size = sizeOf(alt) || s.size; s.color = colorOf(alt) || s.color; }
      }
      var err = ROOT.querySelector('[data-err]'); if (err) err.hidden = true;
      refresh(forK);
      var nb = ROOT.querySelector('.skup__card[data-k="' + forK + '"] [' + attr + '="' + val + '"]'); if (nb) { try { nb.focus({ preventScroll: true }); } catch (x) {} }
    }
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(ROOT.querySelectorAll('button:not([disabled]), a[href]')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === a || document.activeElement === ROOT.querySelector('.skup__panel'))) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function drag() {
    var panel = ROOT.querySelector('.skup__panel'), y0 = null, dy = 0;
    panel.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750 || panel.scrollTop > 0 || e.target.closest('.skup__cards, button, a')) { y0 = null; return; }
      y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none';
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (y0 == null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (y0 == null) return;
      panel.style.transition = '';
      if (dy > 110) close(); else panel.style.transform = '';
      y0 = null;
    });
  }

  /* ---------- кога да се покаже ---------- */
  function addedItem(state) {
    if (!state) return null;
    if (state.product_id === D.main && state.variant_id) return state;
    if (state.items && !('token' in state) && !('item_count' in state)) {
      for (var i = 0; i < state.items.length; i++) if (state.items[i].product_id === D.main) return state.items[i];
    }
    return null;
  }
  function inCart(handle) { return !!(CART && CART.items.some(function (i) { return i.handle === handle; })); }
  function defaults() {
    /* размер: същият като на добавения продукт (ако го има); цвят: същият, после близък (Truffle↔Bison), после Noire; само налични */
    var o = (ADDED.variant_options || []), mSize = o.filter(isSize)[0], mColor = o.filter(function (x) { return x && !isSize(x); })[0];
    var NEAR = { Truffle: 'Bison', Bison: 'Truffle', Oatmilk: 'Noire' };
    SEL = {};
    OFFERS.forEach(function (off) {
      off.items.forEach(function (it) {
        if (!it.pick) return;
        var ss = values(it.p, 'size'), cs = values(it.p, 'color'), s = SEL[it.k] = {};
        var cols = [mColor, NEAR[mColor], 'Noire'].filter(function (c) { return c && cs.indexOf(c) > -1; });
        var size = (mSize && ss.indexOf(mSize) > -1) ? mSize : null, wants = [], v;
        if (size) { cols.forEach(function (c) { wants.push({ size: size, color: c }); }); wants.push({ size: size }); v = firstAvail(it.p, wants); }
        if (v) { s.size = sizeOf(v); s.color = colorOf(v); }
        else {
          v = firstAvail(it.p, cols.map(function (c) { return { color: c }; }).concat([{}]));
          if (v) s.color = colorOf(v);
          if (ss.length < 2 && v) s.size = sizeOf(v);
        }
        it.help = ss.length > 1 && !s.size;
      });
    });
  }
  function start(added) {
    ADDED = added;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      CART = cart;
      STEPS = [];
      OFFERS.forEach(function (off, n) { if (!inCart(off.h)) STEPS.push(n); });
      if (!STEPS.length) { ORIG_OPEN.call(CD); return; }
      defaults();
      if (ONCE) markSeen();
      show(STEPS[0]);
    }).catch(function () { ORIG_OPEN.call(CD); });
  }
  function hook() {
    CD = document.querySelector('cart-drawer');
    if (!CD || CD.__skup || typeof CD.renderContents !== 'function') return;
    CD.__skup = true;
    ORIG = CD.renderContents; ORIG_OPEN = CD.open;
    var mute = false;
    CD.open = function () { if (mute) return; return ORIG_OPEN.apply(this, arguments); };
    CD.renderContents = function (state) {
      var added = null;
      try { added = addedItem(state); } catch (e) {}
      if (!added || OPEN || (window.Shopify && Shopify.designMode) || (ONCE && seen())) return ORIG.apply(this, arguments);
      mute = true;
      try { ORIG.apply(this, arguments); } finally { setTimeout(function () { mute = false; }, 80); }
      try { start(added); } catch (e) { mute = false; ORIG_OPEN.call(CD); }
    };
  }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(function () { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook(); });
})();
